import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jul 18 2018
 * @author VBr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { AgencyQualityEvaluationDTOConverter, CompetitorPriceConverter, CompetitorPriceHistoryIndexDTOConverter, jsonConversions, ModifiedCompetitorPriceDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { GenericTransportLayer } from '../GenericTransportLayer';
export var CompetitorPriceLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(CompetitorPriceLayer, _GenericTransportLaye);

  function CompetitorPriceLayer() {
    _classCallCheck(this, CompetitorPriceLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorPriceLayer).call(this, CONSTANTS.API.ENDPOINTS.CLEANING));
  }

  _createClass(CompetitorPriceLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.competitorPriceConverter;
    }
  }, {
    key: "getCompetitorPricesInZone",
    value: function getCompetitorPricesInZone(internalProductId, priceZoneId, competitorId) {
      var _this = this;

      var competitorPricesInZonePromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.COMPETITOR_PRICES_IN_ZONE)).post({
        internalProductId: internalProductId,
        priceZoneId: priceZoneId,
        competitorId: competitorId
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      });
      return competitorPricesInZonePromise;
    }
    /**
     *
     * @param productId
     * @param weeksNumber number of weeks, that you want get from BE(passed as query parameter)
     */

  }, {
    key: "getMissingCompetitorPrices",
    value: function getMissingCompetitorPrices(productId, numberOfWeeks) {
      var missingCompetitorPricesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.MISSING_COMPETITOR_PRICES(productId))).get({
        responseType: 'json',
        params: {
          numberOfWeeks: numberOfWeeks
        }
      }).then(function (response) {
        return response.data.result || [];
      });
      return missingCompetitorPricesPromise;
    }
  }, {
    key: "getAgencyQualityEvaluations",
    value: function getAgencyQualityEvaluations() {
      var _this2 = this;

      var agencyQualityEvaluationsPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.AGENCY_QUALITY_EVALUATION)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this2.agencyQualityEvaluationDTOConverter.toObject(item, jsonConversions));
        });
        return arr;
      });
      return agencyQualityEvaluationsPromise;
    }
  }, {
    key: "updateCompetitorPrice",
    value: function updateCompetitorPrice(competitorPrice) {
      var _this3 = this;

      var updateCompetitorPricePromise = api(CONSTANTS.API.ENDPOINTS.UPDATE_COMPETITOR_PRICE(competitorPrice.id)).put(this.getConverter().toDocument(competitorPrice, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this3.getConverter().toObject(Object.assign({}, response.data), jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return updateCompetitorPricePromise;
    }
  }, {
    key: "getCompetitorPriceHistoryIndexes",
    value: function getCompetitorPriceHistoryIndexes(competitorPriceIds, zoneId) {
      var _this4 = this;

      var getCompetitorPriceHistoryIndexesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.COMPETITOR_PRICE_HISTORY_INDEXES)).post({
        competitorPriceIds: competitorPriceIds,
        zoneId: zoneId
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this4.competitorPriceHistoryIndexDTOConverter.toObject(item, jsonConversions));
        });
        return arr;
      });
      return getCompetitorPriceHistoryIndexesPromise;
    }
  }, {
    key: "getModifiedPrices",
    value: function getModifiedPrices(competitorPriceIds) {
      var _this5 = this;

      var getModifiedPricesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.COMPETITOR_MODIFIED_PRICES)).post({
        competitorPriceIds: competitorPriceIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this5.modifiedCompetitorPriceDTOConverter.toObject(item, jsonConversions));
        });
        return arr;
      });
      return getModifiedPricesPromise;
    }
  }]);

  return CompetitorPriceLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", CompetitorPriceConverter)], CompetitorPriceLayer.prototype, "competitorPriceConverter", void 0);

__decorate([Inject, __metadata("design:type", CompetitorPriceHistoryIndexDTOConverter)], CompetitorPriceLayer.prototype, "competitorPriceHistoryIndexDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", AgencyQualityEvaluationDTOConverter)], CompetitorPriceLayer.prototype, "agencyQualityEvaluationDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ModifiedCompetitorPriceDTOConverter)], CompetitorPriceLayer.prototype, "modifiedCompetitorPriceDTOConverter", void 0);